module.exports = __webpack_public_path__ + "static/media/banners_empty.c529dfd5.svg";